import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import classes from './Header.module.scss';

const Header = ({ children, className, ...other }) => {
  return (
    <thead className={cn(classes.base, className)} {...other}>
      {children}
    </thead>
  );
};

Header.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ]),
  className: PropTypes.string
};

export default Header;
